import {
    Box,
    Flex,
    Heading,
    Text,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel
} from '@chakra-ui/react'
import { getFromLocalStorage } from '@/shared/utils/localStorageHelper'
import { BranchType } from '@/shared/api/hooks/useBranches'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { ProtectedPage } from '@/shared/components/ProtectedPage'
import QueueTab from './QueueTab'
import StaleCheckoutTab from './StaleCheckoutTab'

export default function QueuePage() {
    const branch = getFromLocalStorage<BranchType>('currentBranch')

    return (
        <ProtectedPage routeConfig={PROTECTED_ROUTES['/user/teacher/queue']}>
            <Box
                minH={['container.sm', 'container.md']}
                borderRadius={4}
                mx={'auto'}
                py={5}
                px={{ base: 2, sm: 2 }}
            >
                <Flex
                    mb={6}
                    alignItems="center"
                    gap="2"
                    flexWrap="wrap"
                    justifyContent={'space-between'}
                >
                    <Box>
                        <Heading size="md" my={2}>
                            Checkout Queue
                        </Heading>
                        <Text>
                            List of children whose parents have checked out at the
                            entrance but yet to be taken out of the church
                        </Text>
                    </Box>
                </Flex>

                <Tabs colorScheme="brand" size="lg">
                    <TabList>
                        <Tab>Queue</Tab>
                        <Tab>Stale checkout</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel px={0}>
                            <QueueTab branchId={branch?.value || ''} />
                        </TabPanel>

                        <TabPanel px={0}>
                            <StaleCheckoutTab />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </ProtectedPage>
    )
}
